<template>
  <div>
    <v-row>
      <v-col align="left">
        <v-card
          outlined
          class="mx-auto my-12"
          max-width="374"
          color="cardIsland"
        >
          <v-card-title class="text-h6 font-weight-bold">
            <v-icon style="color:#FF5050">mdi-alert</v-icon>&nbsp;{{capitaliseFirstLetter(this.orderType)}} order status:&nbsp;
            <span
              class="text-uppercase"
              style="color:#FF5050"
            >{{orderStatus}}</span>
          </v-card-title>
          <v-card-text>
            This {{orderType}} order is invalid as 5 minutes has passed since the order was created and no payment was received.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title class="text-h6 font-weight-bold">Details</v-card-title>
          <OrderDetails
            :orderType="orderType"
            :isReceipt="true"
          />
          <v-divider></v-divider>
          <v-card-title class="text-h6 font-weight-bold">Next steps</v-card-title>
          <v-card-text>
            As this order is invalid, please start a new buy or sell order from your <router-link to="/dashboard">dashboard</router-link>. <br /> <br />
            However, if you believe you made a payment that did not go through, please <router-link to="/">contact us here</router-link> and quote the <strong> order id </strong> and we'll sort this out for you.
          </v-card-text>

        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OrderDetails from "../OrderDetails.vue"
import { utilsMixin } from '../../mixins/utilsMixin.js'

export default {
  props: ["orderType", "orderStatus"],
  components: {
    OrderDetails,
  },
  mixins: [utilsMixin],
  data() {
    return {
      isNewAddressSelected: false,
      sellOrderNewAddressType: 'bank',
      saveToAddressBook: true,
      toggle_exclusive: 3,
      paymentMethod: 'address',
    }
  },
}
</script>
